export function normalizeStr(v) {
  return (v ?? "").toString().trim().toLowerCase();
}

export function paginate(items, page, rowsPerPage) {
  const total = items.length;
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));
  const safePage = Math.min(Math.max(0, page), pageCount - 1);
  const start = safePage * rowsPerPage;
  const end = start + rowsPerPage;
  return {
    page: safePage,
    pageCount,
    slice: items.slice(start, end),
    rangeText: total === 0 ? "0–0" : `${start + 1}–${Math.min(end, total)}`,
    total,
  };
}

export function buildPageButtons(page, pageCount, maxButtons = 7) {
  const current = page + 1;
  const btns = [];

  if (pageCount <= maxButtons) {
    for (let i = 1; i <= pageCount; i++) btns.push(i);
  } else {
    btns.push(1);
    let start = Math.max(2, current - 1);
    let end = Math.min(pageCount - 1, current + 1);
    if (start > 2) btns.push("...");
    for (let i = start; i <= end; i++) btns.push(i);
    if (end < pageCount - 1) btns.push("...");
    btns.push(pageCount);
  }

  return btns;
}

export function statusBadge(status) {
  const s = normalizeStr(status);
  if (["pago", "paid", "done", "concluido", "concluído"].includes(s)) return "exp-badge exp-info";
  if (["pendente", "pending", "aberto"].includes(s)) return "exp-badge exp-warning";
  if (["cancelado", "cancelled"].includes(s)) return "exp-badge exp-danger";
  return "exp-badge exp-info";
}
